//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

export const InteractionChannel = {
    /** Interaction Channel GUID for bible events. */
    BibleEvents: "45B6C8CD-5016-4FCF-9AED-A7EECFE00C5E",
    /** Interaction Channel GUID for all Email, SMS, etc */
    Communication: "C88A187F-0343-4E7C-AF3F-79A8989DFA65",
    /** Interaction Channel GUID for interactive experience participation. */
    InteractiveExperiences: "CAB85FAA-7A28-4986-B485-A02299E998A8",
    /** Interaction Channel GUID for media events. */
    MediaEvents: "D5B9BDAF-6E52-40D5-8E74-4E23973DF159",
    /** Interaction Channel GUID for prayer events. */
    PrayerEvents: "3D49FB99-94D1-4F63-B1A2-30D4FEDE11E9",
    /** Internal Website */
    RockRms: "C9CEF6C4-E1EA-4E1F-B8D7-0172236A3F09",
    /** Interaction Channel GUID for short links */
    ShortLinks: "AEFF9B52-AE61-8EBB-4F43-37C152342076",
    /** Interaction Channel GUID for wifi presence */
    WifiPresence: "23888303-4847-4C80-93E2-4C5EB8029D18",
    /** Interaction Channel GUID Views and Completions for Workflow Entry Forms. */
    WorkflowLaunches: "DAA17190-7119-4901-B105-26C6B5E4CDB4",
};
